import {
  makeStyles,
  Skeleton,
  SkeletonItem,
  tokens,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useClasses = makeStyles({
  skeletonRow: {
    marginBottom: tokens.spacingVerticalXS,
  },
});

export const TagTreeSkeleton = () => {
  const classes = useClasses();
  const { t } = useTranslation();

  return (
    <div>
      <Skeleton aria-label={t("loading")}>
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
        <SkeletonItem className={classes.skeletonRow} size={28} />
      </Skeleton>
    </div>
  );
};
